import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

import { Document } from '../../leads/document/document';
import { MODULE_SEQ } from '../../../core/shared/models/picklist.model';
import {
  FO_LTR_DOC_SEQ,
  FO_LTR_ROLES,
  hasFoLtrRole,
} from '../shared/models/fo-ltr-status.model';

@Component({
  selector: 'app-fo-ltr-docs',
  standalone: true,
  imports: [CommonModule, Document, TranslatePipe],
  templateUrl: './fo-ltr-docs.html',
  styleUrl: './fo-ltr-docs.css',
})
export class FoLtrDocs implements OnInit, OnDestroy {
  crdtFoLtrSeq: number | null = null;

  readonly FACILITY_OFFER_LETTER_MODULE_SEQ = MODULE_SEQ.FACILITY_OFFER_LETTER;

  // ================= TABS =================
  activeTab: 'all' | 'required' = 'all';

  setTab(tab: 'all' | 'required'): void {
    this.activeTab = tab;
  }

  /**
   * FOL new flow: the Account Manager (LNLY_AM) uploads here —
   *  - "Required Documents": the issue-flag documents, once the letter is
   *    approved (902), each from its checklist row;
   *  - "All Documents": the other category-13 documents, which the backend
   *    allows (get-fo-ltr-doc `canUpload`) only once every issue document's
   *    signed copy is final.
   * The offer letter document (36) is handled on the Facility Offer Letter
   * list, so it is never offered here. Every other role views only; the RO
   * reviews from the list's "Pending Review" tab.
   */
  // Document type 51 is not uploaded from the CP Documents tab either.
  private readonly OFFER_LETTER_DOC_SEQS = [FO_LTR_DOC_SEQ, 51];

  get uploadExcludedDocSeqs(): number[] {
    return this.OFFER_LETTER_DOC_SEQS;
  }

  get isAccountManager(): boolean {
    return hasFoLtrRole(FO_LTR_ROLES.AM);
  }

  private subs: Subscription[] = [];

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.subs.push(
      this.route.paramMap.subscribe((params) => {
        const id = params.get('id');

        this.crdtFoLtrSeq = id ? +id : null;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }
}